/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".news-container {\n  margin: 0px 20px 20px 20px; }\n\nhtml {\n  min-height: 100vh; }\n\n.news-header {\n  color: #4798E1; }\n\n.news-content {\n  color: #ABB1BA; }\n\n.news-content img {\n  width: 100% !important; }\n"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/news/news.component.scss.ngstyle.js.pre-build-optimizer.js